module.exports = __webpack_public_path__ + "static/media/S (26).a32f6eac.jpg";